import { call, put, takeEvery } from 'redux-saga/effects';

import axiosInstance from '../api/axiosInstance';
import { FETCH_NOTIFICATION_FAILURE, FETCH_NOTIFICATION_REQUEST, FETCH_NOTIFICATION_SUCCESS, UPDATE_NOTIFCATION_FAILURE, UPDATE_NOTIFCATION_REQUEST, UPDATE_NOTIFCATION_SUCCESS } from '../actions/NotificationActions';

function* fetchNotificationSaga() {
  try {

    const response = yield call(axiosInstance.get, "/allnotifications");
    const notificationData = response.data;

    // Dispatch success action with user role
    yield put({ type: FETCH_NOTIFICATION_SUCCESS, payload: notificationData });
  } catch (error) {
    // Dispatch failure action on error
    yield put({ type: FETCH_NOTIFICATION_FAILURE, payload: { error: error.message } });
  }
}


function* updatenotificationSaga(action) {
  try {

    const response = yield call(axiosInstance.put, "/updatenotification", action.payload);
  
 if (response.data) {
      // Dispatch an action indicating success
      yield put({ type: UPDATE_NOTIFCATION_SUCCESS , payload: { notificationId: response.data._id} });
    }
    // Dispatch success action with user role
  } catch (error) {
    // Dispatch failure action on error
    yield put({ type: UPDATE_NOTIFCATION_FAILURE, payload: { error: error.message } });
  }
}

// Watcher Saga to trigger fetch user data saga
function* fetchNotificationDataSaga() {
  yield takeEvery(FETCH_NOTIFICATION_REQUEST, fetchNotificationSaga);
  yield takeEvery(UPDATE_NOTIFCATION_REQUEST, updatenotificationSaga);
}

export default fetchNotificationDataSaga;
